import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/action', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-300/30'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-book-open-line text-foreground-50 text-lg"></i>
          </div>
          <span className="font-heading text-xl font-bold text-foreground-50 tracking-wide">
            韩漫画网
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${
                location.pathname === link.to
                  ? 'text-primary-400'
                  : 'text-foreground-200 hover:text-foreground-50'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Desktop Right */}
        <div className="hidden md:flex items-center gap-4">
          <button className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-300 hover:text-foreground-50 hover:bg-background-300/50 transition-colors cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-lg"></i>
          </button>
          <Link
            to="/favorites"
            className="text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors whitespace-nowrap"
          >
            收藏
          </Link>
          <Link
            to="/history"
            className="text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors whitespace-nowrap"
          >
            历史
          </Link>
          <button className="px-5 py-2 rounded-full bg-background-950 text-background-50 text-sm font-semibold hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer">
            登录
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-200 hover:text-foreground-50 transition-colors cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu Panel */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-b border-background-300/30">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'text-primary-400'
                    : 'text-foreground-200 hover:text-foreground-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="h-px bg-background-300/40" />
            <Link to="/favorites" className="text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors whitespace-nowrap">
              收藏
            </Link>
            <Link to="/history" className="text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors whitespace-nowrap">
              历史
            </Link>
            <button className="w-full px-5 py-2.5 rounded-full bg-foreground-50 text-background-50 text-sm font-semibold hover:bg-foreground-100 transition-colors whitespace-nowrap cursor-pointer">
              登录
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}